// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__156rS","title":"BackImages_title__2bVFk","images":"BackImages_images__11ZyV"};